// removed by extract-text-webpack-plugin
module.exports = {"awards":"_2KjTk5D9PrreYQyOvOy0AX","item":"_1bxdMdqjt7aV5nUAx03QlW","prize":"_5LU8evm1p4JJY3urQh7eg","competition":"Glt4DcuxQBgBfcqraNNvD","organization":"_1bPjdGatgAOc6EWbsug_lg","time":"_2woAhciHVGYPpxrC0CG8Or","role":"_3bUZ6UYGpZfANv--ceg0bz"};


/*****************
 ** WEBPACK FOOTER
 ** ../components/AwardsSection.module.scss
 ** module id = 1386
 ** module chunks = 0
 **/